<!--
    T34: the wrapping <div> goes and the list is this component's own root. r13 draws the box as
    `.ftd-r13-search > .ftd-menuwrap > .ftd-search` with nothing between them (`r13-top-bar.html:142-144`),
    and a pass-through <div> here put a fourth element in that chain which the box's width rule would
    then have had to reach through. Nothing else about this component changed.

    (The two commented-out lines that stood under the list -- "The selected country name will be visible
    below, when selected" and `{{ dropdownSelection.name }}` -- were template comments, which Vue strips,
    and they are noted here rather than carried into a template that now has a single root.)
-->
<template>
    <DropdownList :mobile_only="this.is_mobile" @on-item-selected="selectedItem($event)" />
</template>

<script>
    import DropdownList from './SearchDropdown';

    export default {
        name: "InputWithDropdown",
        data () {
            return {
                dropdownSelection: {},
                is_mobile: false
            }
        },
        created() {
            this.is_mobile = this.mobile_only ?? false;
        },
        props:{
            mobile_only: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DropdownList
        },
        methods: {
            selectedItem($event) {
                this.dropdownSelection = $event;
                window.location = this.dropdownSelection.link;
            },
        }
    }
</script>

